<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择时间类型',ischange:true,width:'200px',}" 
                :value="param.timetype"
                :list="timetypelist"
                @finish="(val)=> {
                    param.timetype=val.value;
                    param.time=[];
                    param.begin='';
                    param.end='';
                    param.ischange=true;
                    if(val.value==1) {
                        param.type='date';
                        param.timeformat='YYYY-MM-DD';
                        param.begin=$method.GetBeforeTimes(1,7);
                        param.end=$method.GetNowTimes(1);
                    }else if(val.value==2) {
                        param.type='month';
                        param.timeformat='YYYY-MM';
                        param.begin=$method.GetBeforeTimes(2,6);
                        param.end=$method.GetNowTimes(2);
                    }else if(val.value==3) {
                        param.type='year';
                        param.timeformat='YYYY';
                        param.begin=$method.GetBeforeTimes(3,3);
                        param.end=$method.GetNowTimes(3);
                    }
                    console.log(param);
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime :option="{placeholder:'开始时间',type:param.type,format:param.timeformat,width:'200px',ischange:true,clearable:false}"
                :value="param.begin"
                @finish="(val)=> {
                    param.begin=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wctime :option="{placeholder:'结束时间',type:param.type,format:param.timeformat,width:'200px',ischange:true,clearable:false}"
                :value="param.end"
                @finish="(val)=> {
                    param.end=val.value;
                    param.ischange=true;
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item style="position:absolute;right:0;">
        <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
        <el-switch v-model="param.isorder" active-text="查看趋势图、分布图" 
            @change="(val)=>{
                param.timetype=1;
                param.type='date';
                param.timeformat='YYYY-MM-DD';
                param.begin=$method.GetBeforeTimes(1,7);
                param.end=$method.GetNowTimes(1);
                this.param.change=true;
                GetList();
            }" 
        />
        </div>
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div v-if="!param.isorder">
<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="time" label="时间" align="center" fixed="left" min-width="100" />
        <el-table-column prop="goodsnums" label="数据发布" align="center"/>
        <!-- <el-table-column prop="salenums" label="发布闲置" align="center"/>
        <el-table-column prop="buynnums" label="发布求购" align="center"/>
        <el-table-column prop="person_nums" label="个人发布" align="center"/>
        <el-table-column prop="compony_nums" label="企业发布" align="center"/> -->
        <el-table-column prop="comments" label="留言数量" align="center"/>
        <el-table-column prop="membernums" label="会员注册" align="center"/>
        <!-- <el-table-column prop="member_person_nums" label="个人注册" align="center"/> -->
        <el-table-column prop="authnum" label="认证数量" align="center"/>
        <!-- <el-table-column prop="auth_person_num" label="个人认证数量" align="center"/>
        <el-table-column prop="auth_business_num" label="企业认证数量" align="center"/> -->
        <el-table-column prop="auth_business_price" label="企业认证金额" align="center"/>
        <el-table-column prop="vip_num" label="vip充值次数" align="center"/>
        <el-table-column prop="vip_price" label="vip充值金额" align="center"/>
        <el-table-column prop="cash_num" label="红包充值数量" align="center"/>
        <el-table-column prop="cash_price" label="红包充值价格" align="center"/>
        <el-table-column prop="add_qun_num" label="付费入群人数" align="center"/>
        <el-table-column prop="add_qun_price" label="付费入群金额" align="center"/>

        <el-table-column label="操作" align="center" min-width="120">
            <template #default="scope">
            <div class="TTL-btn-info">
            <wcbutton :option="{title:'详情'}" @finish="$parent.JUMPVIEW({name:'EsStatoperateDetail',param:scope.row})" class="right10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>
<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>
</div>


<!-- 趋势图、分布图 -->
<div v-if="param.isorder" :ref="objloading">
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">发布数据总数量趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="goodsnumsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">发布闲置数据数量趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="salenumsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">发布求购数据数量趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="buynnumsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">评论数量趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="commentsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">个人发布数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="person_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">个人发布闲置数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="person_sale_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">个人发布求购数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="person_buy_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">企业发布数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="compony_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">企业发布闲置数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="compony_sale_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">企业发布求购数据趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="compony_buy_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">会员新增趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="membernumsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">新增个人会员趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="member_person_numsObj.ref" />
    </div>
    <div class="TTL-pie-infos top20">
        <span class="TTL-pie-title">新增企业会员趋势图</span>
        <div class="TTL-pie-infos-tu" :ref="member_compony_numsObj.ref" />
    </div>
</div>


</template>

<script>
import INTERFACE_MODEL_STAT from '@/Interface/Es/stat';
import * as echarts from 'echarts';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'StatOperate',
            param: {
                isorder:false,
                timetype:1,
                type:'date',
                timeformat:'YYYY-MM-DD',
                begin:this.$method.GetBeforeTimes(1,7),
                end:this.$method.GetNowTimes(1),
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            timetypelist:[
                {id:1,name:'按日期搜索'},
                {id:2,name:'按月份搜索'},
                {id:3,name:'按年份搜索'},
            ],
            list:[],
            listpie:[],

            //发布总量
            goodsnumsObj: {
                ref:'goodsnumsobj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#666eeb'
                        }
                    }]
                },
            },

            //发布闲置总量
            salenumsObj: {
                ref:'salenumsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#d8a51c'
                        }
                    }]
                },
            },

            //发布求购总量
            buynnumsObj: {
                ref:'buynnumsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#3f28eb'
                        }
                    }]
                },
            },

            //商品评论数量
            commentsObj: {
                ref:'commentsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#9d953b'
                        }
                    }]
                },
            },

            //个人发布数量总量
            person_numsObj: {
                ref:'person_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#10a657'
                        }
                    }]
                },
            },

            //个人发布闲置数量总量
            person_sale_numsObj: {
                ref:'person_sale_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#44ba3b'
                        }
                    }]
                },
            },

            //个人发布求购数量总量
            person_buy_numsObj: {
                ref:'person_buy_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#7be910'
                        }
                    }]
                },
            },


            //企业发布数量总量
            compony_numsObj: {
                ref:'compony_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#10d7e9'
                        }
                    }]
                },
            },


            //企业发布闲置数量总量
            compony_sale_numsObj: {
                ref:'compony_sale_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#1095e9'
                        }
                    }]
                },
            },


            //企业发布求购数量总量
            compony_buy_numsObj: {
                ref:'compony_buy_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#106ce9'
                        }
                    }]
                },
            },


            //新增会员总量
            membernumsObj: {
                ref:'membernumsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#7138e6'
                        }
                    }]
                },
            },


            //新增个人会员
            member_person_numsObj: {
                ref:'member_person_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#a238e6'
                        }
                    }]
                },
            },


            //新增企业会员
            member_compony_numsObj: {
                ref:'member_compony_numsObj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#e038e6'
                        }
                    }]
                },
            },


            


        }
    },

    mounted() {
        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            var METHOD=!this.param.isorder ? 'GET_OPERATE_DATE' : 'GET_OPERATE_PIE';
            INTERFACE_MODEL_STAT[METHOD](this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 !this.param.isorder ? this.list=res.data.list : this.listpie=res.data.list;
                 //更新图形数据
                 if(this.param.isorder) this.updatePies();
            });
        },


        //更新图形数据
        updatePies() {

            //总发布数据量
            this.goodsnumsObj.option.xAxis.data=this.listpie.bar.goodsnums.time;
            this.goodsnumsObj.option.series[0].data=this.listpie.bar.goodsnums.data;
            var goodsnumDom = this.$refs[this.goodsnumsObj.ref];
            var goodsnumChart = echarts.init(goodsnumDom);
            goodsnumChart.setOption(this.goodsnumsObj.option);

            //闲置发布数据量
            this.salenumsObj.option.xAxis.data=this.listpie.bar.salenums.time;
            this.salenumsObj.option.series[0].data=this.listpie.bar.salenums.data;
            var salenumsDom = this.$refs[this.salenumsObj.ref];
            var salenumsChart = echarts.init(salenumsDom);
            salenumsChart.setOption(this.salenumsObj.option);

            //求购发布数据量
            this.buynnumsObj.option.xAxis.data=this.listpie.bar.buynnums.time;
            this.buynnumsObj.option.series[0].data=this.listpie.bar.buynnums.data;
            var buynnumsDom = this.$refs[this.buynnumsObj.ref];
            var buynnumsChart = echarts.init(buynnumsDom);
            buynnumsChart.setOption(this.buynnumsObj.option);

            //评论数量趋势图
            this.commentsObj.option.xAxis.data=this.listpie.bar.comments.time;
            this.commentsObj.option.series[0].data=this.listpie.bar.comments.data;
            var commentsObjDom = this.$refs[this.commentsObj.ref];
            var commentsObjChart = echarts.init(commentsObjDom);
            commentsObjChart.setOption(this.commentsObj.option);

            //个人发布趋势图
            this.person_numsObj.option.xAxis.data=this.listpie.bar.person_nums.time;
            this.person_numsObj.option.series[0].data=this.listpie.bar.person_nums.data;
            var person_numsObjDom = this.$refs[this.person_numsObj.ref];
            var person_numsObjChart = echarts.init(person_numsObjDom);
            person_numsObjChart.setOption(this.person_numsObj.option);

            //个人发布闲置趋势图
            this.person_sale_numsObj.option.xAxis.data=this.listpie.bar.person_sale_nums.time;
            this.person_sale_numsObj.option.series[0].data=this.listpie.bar.person_sale_nums.data;
            var person_sale_numsObjDom = this.$refs[this.person_sale_numsObj.ref];
            var person_sale_numsObjChart = echarts.init(person_sale_numsObjDom);
            person_sale_numsObjChart.setOption(this.person_sale_numsObj.option);

            //个人发布求购趋势图
            this.person_buy_numsObj.option.xAxis.data=this.listpie.bar.person_buy_nums.time;
            this.person_buy_numsObj.option.series[0].data=this.listpie.bar.person_buy_nums.data;
            var person_buy_numsObjDom = this.$refs[this.person_buy_numsObj.ref];
            var person_buy_numsObjChart = echarts.init(person_buy_numsObjDom);
            person_buy_numsObjChart.setOption(this.person_buy_numsObj.option);

            //企业发布数量总量
            this.compony_numsObj.option.xAxis.data=this.listpie.bar.compony_nums.time;
            this.compony_numsObj.option.series[0].data=this.listpie.bar.compony_nums.data;
            var compony_numsObjDom = this.$refs[this.compony_numsObj.ref];
            var compony_numsObjChart = echarts.init(compony_numsObjDom);
            compony_numsObjChart.setOption(this.compony_numsObj.option);

            //企业发布闲置数量
            this.compony_sale_numsObj.option.xAxis.data=this.listpie.bar.compony_sale_nums.time;
            this.compony_sale_numsObj.option.series[0].data=this.listpie.bar.compony_sale_nums.data;
            var compony_sale_numsDom = this.$refs[this.compony_sale_numsObj.ref];
            var compony_sale_numsChart = echarts.init(compony_sale_numsDom);
            compony_sale_numsChart.setOption(this.compony_sale_numsObj.option);

            //企业发布求购数量
            this.compony_buy_numsObj.option.xAxis.data=this.listpie.bar.compony_buy_nums.time;
            this.compony_buy_numsObj.option.series[0].data=this.listpie.bar.compony_buy_nums.data;
            var compony_buy_numsObjDom = this.$refs[this.compony_buy_numsObj.ref];
            var compony_buy_numsObjChart = echarts.init(compony_buy_numsObjDom);
            compony_buy_numsObjChart.setOption(this.compony_buy_numsObj.option);

            //新增会员数量
            this.membernumsObj.option.xAxis.data=this.listpie.bar.membernums.time;
            this.membernumsObj.option.series[0].data=this.listpie.bar.membernums.data;
            var membernumsObjDom = this.$refs[this.membernumsObj.ref];
            var membernumsObjChart = echarts.init(membernumsObjDom);
            membernumsObjChart.setOption(this.membernumsObj.option);

            //新增个人会员数量
            this.member_person_numsObj.option.xAxis.data=this.listpie.bar.member_person_nums.time;
            this.member_person_numsObj.option.series[0].data=this.listpie.bar.member_person_nums.data;
            var member_person_numsObjDom = this.$refs[this.member_person_numsObj.ref];
            var member_person_numsObjChart = echarts.init(member_person_numsObjDom);
            member_person_numsObjChart.setOption(this.member_person_numsObj.option);

            //新增企业会员数量
            this.member_compony_numsObj.option.xAxis.data=this.listpie.bar.member_compony_nums.time;
            this.member_compony_numsObj.option.series[0].data=this.listpie.bar.member_compony_nums.data;
            var member_compony_numsDom = this.$refs[this.member_compony_numsObj.ref];
            var member_compony_numsChart = echarts.init(member_compony_numsDom);
            member_compony_numsChart.setOption(this.member_compony_numsObj.option);

        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.TTL-pie-infos {display: inline-block;width:100%;}
.TTL-pie-infos-tu {display: inline-block;width:100%;height:300px;}
.TTL-pie-title {font-size:13px;color:#503b11;display: inline-block;width:100%;text-align: center;}
</style>